import type { definitions } from '@luxuryescapes/contract-trip'

import type {
  CopyPublicTripResponse,
  GetPublicTripResponse,
} from './types'
import { baseUri, getOptions } from '../utils'

import request from 'api/requestUtils'

export function getPublicTrip(
  tripId: string,
  accessToken?: string,
): Promise<definitions['fullPublicTrip']> {
  const uri = `${baseUri}/public/${tripId}`
  return request
    .get<GetPublicTripResponse>(uri, getOptions(accessToken))
    .then((response) => response.result)
}

export function fetchPublicId(
  tripId: string,
  accessToken?: string,
): Promise<string | null> {
  const uri = `${baseUri}/public/${tripId}/id`
  return request
    .get<App.ApiResponse<string | undefined>>(uri, getOptions(accessToken))
    .then((res) => res.result ?? null)
}

export function createPublicId(
  tripId: string,
  accessToken?: string,
): Promise<string> {
  const uri = `${baseUri}/public/${tripId}/id`
  return request
    .post<App.ApiResponse<string>, {}>(uri, {}, getOptions(accessToken))
    .then((res) => res.result)
}

export function deletePublicTripId(
  tripId: string,
  accessToken?: string,
): Promise<string> {
  const uri = `${baseUri}/public/${tripId}/id`
  return request
    .delete<App.ApiResponse<string>>(uri, getOptions(accessToken))
    .then((res) => res.result)
}

type CopyArgs = {
  publicTripId: string
  name: string
  regionCode: string
  tripItemIds?: Array<string>
}

export function copyPublicTrip(
  { publicTripId, name, tripItemIds, regionCode }: CopyArgs,
  accessToken?: string,
): Promise<definitions['fullTrip']> {
  const uri = `${baseUri}/public/${publicTripId}/copy`
  return request
    .post<CopyPublicTripResponse, Omit<CopyArgs, 'publicTripId'>>(
      uri,
      { name, regionCode, tripItemIds },
      getOptions(accessToken),
    )
    .then((res) => res.result)
}
